/**
 * CUSTOMERS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import { getCustomers, getCustomer, printCustomer, createCustomers, updateCustomers, deleteCustomers } from "Core/companies/customers/config/api.customers";
import { store } from "Store/store";

const state = {
    page: {},
    form: {},
    customers: [],
    customer_options: [],
    packing_list_fields_options: [],
    selectedCustomer: {},
    customers_filter: {
        search: "",
        status: "1",
        user_id: "",
        with_tokens: "",
        module: "",
        page_size: 0,
        page_num: 0,
    },
    rules_customers: {
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company: {
            name: "company",
            rules: "trim|max_length[100]|required",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        website: {
            name: "website",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        turn_around_days: {
            name: "turn_around_days",
            rules: "trim|max_length[3]|numeric[0]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        payment_term_id: {
            name: "payment_term_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        correspondence_method: {
            name: "correspondence_method",
            rules: "trim|max_length[10]",
            max_len: "10",
            min_len: "",
            default_value: "electronic",
        },
        has_nda: {
            name: "has_nda",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        has_contract: {
            name: "has_contract",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        ship_label_type: {
            name: "ship_label_type",
            rules: "trim|max_length[6]|required",
            max_len: "6",
            min_len: "",
            default_value: "normal",
        },
        status: {
            name: "status",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        shipping_number: {
            name: "shipping_number",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    customers: (state) => {
        return state.customers;
    },
    selectedCustomer: (state) => {
        return state.selectedCustomer;
    },
};

// actions
const actions = {
    async fetchCustomers({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getCustomers({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }
                if (body.options) {
                    commit("mutate", {
                        property: "customer_options",
                        with: response.data.customers,
                    });
                } else {
                    commit("mutate", {
                        property: "customers",
                        with: response.data.customers,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchCustomer({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };
            response = await getCustomer(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedCustomer",
                    with: response.data.customer,
                });

                commit("mutate", {
                    property: "packing_list_fields_options",
                    with: response.data.packing_list_fields_options,
                });

                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printCustomer({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printCustomer(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveCustomer({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (payload.id) {
                body["company_id"] = payload.id;
            }

            if (typeof body["company_id"] === "undefined" || body["company_id"] == null || body["company_id"] == "") {
                delete body["company_id"];
                response = await createCustomers({ body: body, headers: config.headers });
            } else {
                let company_id = body["company_id"];
                delete body["company_id"];
                response = await updateCustomers({ body: body, headers: config.headers }, company_id);
            }

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedCustomer",
                    with: response.data.customer,
                });
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteCustomer({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteCustomers(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
    // async initializeMutate({ rootState, commit, dispatch }, payload) {
    //     store.commit("mutateCustomer", {
    //         property: "notes",
    //         with: payload.with,
    //     });
    // },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    mutateCustomer(state, payload) {
        state.selectedCustomer[payload.property] = payload.with;
    },
    resetCustomersStore(state) {
        state.page = {};
        state.form = {};
        state.customers = [];
        state.customer_options = [];
        state.packing_list_fields_options = [];
        state.selectedCustomer = {};
        state.customers_filter = {
            search: "",
            status: "1",
            user_id: "",
            with_tokens: "",
            module: "",
            page_size: 0,
            page_num: 0,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
